import { OffersPromoRepository } from "../Repository/OffersPromoRepository";

export interface RemoveModalItemTableUseCase {
    invoke: (modalId : number) => Promise<boolean>;
  }
  
  export class RemoveModalItemTable implements RemoveModalItemTableUseCase {
    private repo: OffersPromoRepository;
    constructor(_repo: OffersPromoRepository) {
      this.repo = _repo;
    }
  
    async invoke(modalId : number){
       
        if(!modalId){
            throw new Error(
                "Ha ocurrido un error!"
              );
        }
         
        const deleted  = await this.repo.removeModalItemTable(modalId);
        return deleted;
    }
  }